import React from 'react';
import { Link } from 'react-router-dom';

export default function VendorNavigation() {
  return (
    <div>
      <ul className='nav justify-content-center'>
        <li className='nav-item'>
          <Link className='nav-link active' to={'/Vendor'}>
            Vendors
          </Link>
        </li>
        <li className='nav-item'>
          <Link className='nav-link' to={'/Vendor'}>
            Recharge Account
          </Link>
        </li>
        <li className='nav-item'>
          <Link className='nav-link' to={'/Vendor'}>
            Recharge History
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className='nav-link'
            to={'/Vendor'}
            tabIndex='-1'
            aria-disabled='true'
          >
            Sales History
          </Link>
        </li>
        <li className='nav-item'>
          <Link className='nav-link' to={'/Vendor'} tabIndex='-1'>
            EOS History
          </Link>
        </li>
      </ul>
    </div>
  );
}
